import React, { useContext, useEffect, useState } from "react";
import {
  Drawer,
  IconButton,
  Typography,
  Slider,
  Avatar,
  Box,
  Divider,
  Button,
  Grid,
  Tooltip,
} from "@mui/material";
import {
  Edit,
  Logout,
  VolumeUp,
  VolumeDown,
  Visibility,
  Wallet,
  HelpOutline,
  Close,
  AttachMoney,
  VolumeOff,
  Dashboard,
} from "@mui/icons-material";
import EditProfileModal from "./EditPrifileModal";
import StripeEarningsModal from "./StripeEarningsModal";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { getBadgeByLevel } from "../@shared/utils/Utils";
import { MainContext } from "../App";
import { getDatabase, ref, remove } from "firebase/database";
import { useLocation } from "react-router-dom";
import { useAudioManager } from "../@shared/utils/useAudioManager";
import { useSoundsStore } from "../@shared/store/useSoundsStore";
import AudioManager from "../@shared/utils/AudioManager";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../@shared/firebase/config";

export default function SettingsDrawer({
  open,
  onClose,
  screen,
  onclick,
  //   sfxVolume,
  //   musicVolume,
  //   setSfxVolume,
  //   setMusicVolume,
}) {
  const { userData, logout } = useAuthStore();
  const { navigate, setPartyId, setIsHost } = useContext(MainContext);
  const [editProfileVisible, setEditProfileVisible] = useState(false);
  const [stripeModalVisible, setStripeModalVisible] = useState(false);
  const sfxVolume = useSoundsStore((s) => s.sfxVolume);
  const setSfxVolume = useSoundsStore((s) => s.setSfxVolume);
  const musicVolume = useSoundsStore((s) => s.musicVolume);
  const setMusicVolume = useSoundsStore((s) => s.setMusicVolume);

  const isMusicMuted = useSoundsStore((s) => s.isMusicMuted);
  const toggleMusicMute = useSoundsStore((s) => s.toggleMusicMute);

  const [audioState, setAudioState] = useState(AudioManager.audioCtx.state);

  useEffect(() => {
    const checkState = () => setAudioState(AudioManager.audioCtx.state);
    const interval = setInterval(checkState, 500); // poll audio state
    return () => clearInterval(interval);
  }, []);

  const handleToggleMute = async () => {
    if (audioState !== "running") {
      try {
        console.log("🔊 Resuming audio context...");
        await AudioManager.audioCtx.resume();
        setAudioState("running");
      } catch (err) {
        console.error("Audio resume failed:", err);
      }
      return;
    }

    toggleMusicMute();
  };

  const onVolumeChange = async (evt, value) => {
    setMusicVolume(value);
    AudioManager.setMusicVolume(value);

    if (AudioManager.audioCtx.state !== "running") {
      try {
        console.log("🔊 Resuming audio context from volume slider...");
        await AudioManager.audioCtx.resume();
      } catch (err) {
        console.error("AudioContext resume failed:", err);
      }
    }
  };

  // const onVolumeChange = (evt, value) => {
  //   setMusicVolume(value);
  //   AudioManager.setMusicVolume(value);
  // };

  useEffect(() => {
    setTimeout(() => {
      setPartyId(null);
      setIsHost(null);
    }, 2000);
  }, []);

  useEffect(() => {
    // whenever the zustand store’s musicVolume changes,
    // tell the AudioManager to update the actual <audio> node
    AudioManager.setMusicVolume(musicVolume);
  }, [musicVolume]);

  const handleLogout = () => {
    logout();
    alert("Logged Out: You have been signed out.");
  };

  const removePlayerPresence = async () => {
    const rtdb = getDatabase();

    const userDocRef = doc(db, "users", userData.id);
    await updateDoc(userDocRef, {
      partyId: null,
      isHost: null,
    });
    const presenceRef = ref(rtdb, `presence/${userData.id}`);
    await remove(presenceRef);
  };

  return (
    <>
      <Drawer
        anchor="left"
        open={open}
        onClose={onClose}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        PaperProps={{ sx: { width: 360, bgcolor: "#16116e", p: 2 } }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color="white">
            Settings
          </Typography>
          <IconButton onClick={onClose} sx={{ color: "white" }}>
            <Close />
          </IconButton>
        </Box>

        <Box mt={3}>
          <Typography variant="subtitle1" color="white" gutterBottom>
            Profile
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            bgcolor="#00000080"
            p={2}
            borderRadius={2}
          >
            <Avatar
              src={
                userData?.imgUrl ||
                require("../@shared/assets/icons/profile_icon.png")
              }
              alt="avatar"
              sx={{ width: 56, height: 56, mr: 2 }}
            />
            <Box flexGrow={1}>
              <Typography variant="body1" color="white" fontWeight="bold">
                @{userData.username}
              </Typography>
              <Typography variant="caption" color="white">
                {getBadgeByLevel(userData.level).name}
              </Typography>
            </Box>
            <Box textAlign="center">
              <img
                src={getBadgeByLevel(userData.level).badge}
                alt="badge"
                style={{ width: 36, height: 36 }}
              />
              <Typography variant="caption" color="white">
                {userData.level}
              </Typography>
            </Box>
          </Box>

          <Button
            variant="contained"
            color="primary"
            startIcon={<Edit />}
            fullWidth
            sx={{ mt: 2 }}
            onClick={() => setEditProfileVisible(true)}
          >
            Edit Profile
          </Button>

          {(userData.roles.includes("test") ||
            userData.roles.includes("ip_provider") ||
            userData.roles.includes("collection_creator")) && (
            <Box mt={3}>
              <Typography variant="subtitle2" color="white">
                Earnings
              </Typography>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => {
                  userData.stripeId && userData.onboardingComplete
                    ? navigate("/dashboard")
                    : setStripeModalVisible(true);
                }}
                startIcon={
                  userData.stripeId || userData.stripeTestId ? (
                    <AttachMoney />
                  ) : (
                    <Wallet />
                  )
                }
                sx={{ color: "white", borderColor: "white", mt: 1 }}
              >
                {userData.stripeId || userData.stripeTestId ? (
                  <>
                    Dasboard <Dashboard sx={{ ml: 1 }} />
                  </>
                ) : (
                  <Typography sx={{ color: "yellow" }}>
                    Not Connected (click to connect)
                  </Typography>
                )}
              </Button>
            </Box>
          )}

          <Box mt={4}>
            <Typography variant="subtitle1" color="white" gutterBottom>
              Audio
            </Typography>
            <Typography color="white">SFX Volume</Typography>
            <Slider
              value={sfxVolume}
              onChange={(e, newVal) => setSfxVolume(newVal)}
              min={0}
              max={1}
              step={0.01}
              sx={{ color: "#b90c98" }}
            />

            <Typography color="white">Music Volume</Typography>
            <Slider
              value={musicVolume}
              onChange={onVolumeChange}
              min={0}
              max={1}
              step={0.01}
              sx={{ color: "#b90c98" }}
            />
            <Box mt={2}>
              <Button
                // onClick={toggleMusicMute}
                onClick={handleToggleMute}
                variant="outlined"
                fullWidth
                startIcon={
                  audioState !== "running" ? (
                    <VolumeOff />
                  ) : isMusicMuted ? (
                    <VolumeDown />
                  ) : (
                    <VolumeUp />
                  )
                }
                sx={{ color: "white", borderColor: "white" }}
              >
                {audioState !== "running"
                  ? "Resume Audio"
                  : isMusicMuted
                  ? "Unmute Music"
                  : "Mute Music"}
              </Button>
            </Box>
          </Box>

          <Box mt={4} display="flex" flexDirection="column" gap={2}>
            <Button
              startIcon={<HelpOutline />}
              variant="contained"
              color="primary"
              onClick={() => console.log("Support tapped")}
              fullWidth
            >
              Support / FAQ
            </Button>
            <Button
              startIcon={<Logout />}
              variant="contained"
              color="error"
              onClick={() => {
                screen === "world"
                  ? removePlayerPresence()
                  : screen === "gameboard" || screen === "lobby"
                  ? onclick()
                  : handleLogout();
              }}
              fullWidth
            >
              {screen === "world" || screen === "lobby"
                ? "Leave"
                : screen === "gameboard"
                ? "Quit Match"
                : "Log Out"}
            </Button>
            <Typography textAlign="center" color="#aaa" fontSize={12}>
              InfiNFT Royale v1.0.0
            </Typography>
          </Box>
        </Box>
      </Drawer>

      {/* <EditProfileModal
        visible={editProfileVisible}
        onClose={() => setEditProfileVisible(false)}
        userData={userData}
      /> */}

      <StripeEarningsModal
        visible={stripeModalVisible}
        onClose={() => setStripeModalVisible(false)}
      />
    </>
  );
}
